export enum InfluencerListType {
    listAll = 0,
    active = 1,
    applied = 2,
    rejected = 3,
    invited = 4,
}
